import { UiKeys } from '@voicedojo/backend-types';
import { t } from '$lib/i18n';
import { toast } from '$lib/stores/notifications';
import { ApiError, isAbortError } from './client';

// Unreachable API: client.ts reports it to the offline banner, not a toast per call.
export function toastUnhandledRejection(reason: unknown): void {
  if (reason instanceof ApiError) {
    if (reason.status !== 0 && !reason.toastSuppressed) toast.error(reason.message);
    return;
  }
  if (isAbortError(reason)) return;
  toast.error(t(UiKeys.Errors.Unexpected));
}
